import { LOAD_CHANNELS_ALL_CHANNEL, LOAD_CHANNELS_ARTICLE, LOAD_CHANNELS_ARTIST, LOAD_CHANNELS_CHANNEL, LOAD_CHANNELS_MOVIE, LOAD_CHANNELS_MOVIE_PLAYER, LOAD_CHANNELS_SEARCH } from '@/store/protocols'

export default [
    {
        name: 'channel-detail',
        path: '/channels/detail/:id.html',
        component: () => import('./Root.vue'),
        meta: {
            asyncData: LOAD_CHANNELS_CHANNEL.join('/')
        }
    },
    {
        path: '/channels/detail/:id/movies/pages/:page.html',
        component: () => import('./Root.vue'),
        meta: {
            asyncData: LOAD_CHANNELS_CHANNEL.join('/')
        }
    },
    {
        path: '/channels/detail/:id/shorts/pages/:page.html',
        component: () => import('./Root.vue'),
        meta: {
            asyncData: LOAD_CHANNELS_CHANNEL.join('/')
        }
    },
    {
        path: '/channels/detail/:id/yuedus/pages/:page.html',
        component: () => import('./RootArticle.vue'),
        meta: {
            asyncData: LOAD_CHANNELS_CHANNEL.join('/')
        }
    },
    {
        path: '/channels/detail/:id/speekers/pages/:page.html',
        component: () => import('./Root.vue'),
        meta: {
            asyncData: LOAD_CHANNELS_CHANNEL.join('/')
        }
    },
    {
        path: '/channels/detail/:id/comments/pages/:page.html',
        component: () => import('./Root.vue'),
        meta: {
            asyncData: LOAD_CHANNELS_CHANNEL.join('/')
        }
    },
    {
        path: '/channels/all.html',
        component: () => import('./All.vue'),
        meta: {
            asyncData: LOAD_CHANNELS_ALL_CHANNEL.join('/')
        }
    },
    {
        name: 'channel-movies',
        path: '/channels/movies/:id.html',
        component: () => import('./Movie.vue'),
        meta: {
            asyncData: LOAD_CHANNELS_MOVIE.join('/')
        }
    },
    {
        name: 'channel-search',
        path: '/channels/search/:kw/:type?/:page?',
        component: () => import('./Search.vue'),
        meta: {
            asyncData: LOAD_CHANNELS_SEARCH.join('/')
        }
    },
    {
        name: 'channel-movie-player',
        path: '/channels/movie-player/:id/:url?.html',
        component: () => import('./MoviePlayer.vue'),
        meta: {
            asyncData: LOAD_CHANNELS_MOVIE_PLAYER.join('/')
        }
    },
    {
        path: '/channels/authors/:id/index.html',
        component: () => import('./Artist.vue'),
        meta: {
            asyncData: LOAD_CHANNELS_ARTIST.join('/')
        }
    },
    {
        path: '/channels/authors/:id/pages/:page.html',
        component: () => import('./Artist.vue'),
        meta: {
            asyncData: LOAD_CHANNELS_ARTIST.join('/')
        }
    },
    {
        path: '/channels/articles/:id.html',
        component: () => import('./Article.vue'),
        meta: {
            asyncData: LOAD_CHANNELS_ARTICLE.join('/')
        }
    }
]

